import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID,
  HOSTED_PAGE_DO_PAYMENT,
  CHECK_BIN_CARD_NUMBER
} from "./actionTypes"

import {
  getPaymentPageTransactionByUniqueIdSuccess,
  checkBinCardNumberSuccess,
  checkBinCardNumberFail,
  hostedPageDoPaymentSuccess
} from "./actions"

import {
  getPaymentPageTransactionDataByUniqueId,
  hostedPageDoPayment,
  checkBinCardNumber
} from "../../helpers/backend_helper/backend_helper"
import { isCheckBinErrorResponse, toPlainApiError } from "helpers/apiErrorHelper"

function* getPaymentPageTransactionByUniqueId({ payload: paymentPageTransactionFilter }) {
  try {
    const response = yield call(getPaymentPageTransactionDataByUniqueId, paymentPageTransactionFilter)
    localStorage.setItem("Act", response.act);
    if (response == null) { response.error = true }
    yield put(getPaymentPageTransactionByUniqueIdSuccess(response))
  } catch (error) {
    const response = { error: false, errorMessage: "" };
    console.error(error);
    response.error = true;
    response.errorMessage = error.message;
    response.errorStatus = error.response?.status;
    yield put(getPaymentPageTransactionByUniqueIdSuccess(response))
  }
}

function* onHostedPageDoPayment({ payload: record }) {
  try {
    const response = yield call(hostedPageDoPayment, record)
    if (response == null) {
      yield put(hostedPageDoPaymentSuccess({ error: true }))
      return
    }
    if (response.htmlFormSuccess != null && response.htmlFormSuccess !== "") {
      response.secureTransaction = true
    } else if (response.code != null && response.code !== "") {
      response.nonSecureTransaction = true
    }
    yield put(hostedPageDoPaymentSuccess(response))
  } catch (error) {
    const response = { error: true };
    console.log(error);
    response.errorMessage = error.message;
    response.errorStatus = error.response?.status;
    yield put(hostedPageDoPaymentSuccess(response))
  }
}


function* onCheckBinCardNumber({ payload: record }) {
  try {
    const response = yield call(checkBinCardNumber, record)
    if (isCheckBinErrorResponse(response)) {
      yield put(checkBinCardNumberFail(toPlainApiError(response)))
      return
    }
    yield put(checkBinCardNumberSuccess(response))
  } catch (error) {
    try {
      yield put(checkBinCardNumberFail(toPlainApiError(error)))
    } catch (normalizeError) {
      yield put(checkBinCardNumberFail({
        Code: "Error",
        Message: error?.message || "BIN check failed",
        Details: error?.message || "BIN check failed",
        CorrelationId: "",
        validationResults: [],
      }))
    }
  }
}

function* hostedPaymentPageSaga() {

  yield takeEvery(GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID, getPaymentPageTransactionByUniqueId)
  yield takeEvery(HOSTED_PAGE_DO_PAYMENT, onHostedPageDoPayment)
  yield takeEvery(CHECK_BIN_CARD_NUMBER, onCheckBinCardNumber)
}

export default hostedPaymentPageSaga
